// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11xa4","field":"styles_field__T22G8","fieldCol":"styles_fieldCol__3B6Rd","diffCol":"styles_diffCol__FwmXB","diff":"styles_diff__1H6cM"};